var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"section"},[_c('div',{staticClass:"columns"},[_c('div',{staticClass:"column is-8 is-offset-2"},[_c('h1',[_vm._v("Account")]),_c('p',[_vm._v("You are logged in as "+_vm._s(_vm.$auth.user.name))])])])])}
var staticRenderFns = []

export { render, staticRenderFns }